import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppIdSdkAuthenticationSettings = "/apps/:app_id/sdk_authentication_settings";
export const appsAppIdSdkAuthenticationSettingsCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_id/sdk_authentication_settings",
];
